module.exports = __webpack_public_path__ + "static/img/1.dfd3622.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/internationalBrand/hnweR404A/1.jpg
// module id = cVas
// module chunks = 1